import { Plugins } from '@leverege/plugin';
const SymbolizerFactory = Plugins.createFactory('MapBoxSymbolizer', {
  pluginKey: 'symbolizer',
  strategy: Plugins.LOOKUP
});
function getSymbol(model, object, context) {
  if (model == null) {
    return null;
  }
  const c = SymbolizerFactory.get(model);
  if (c) {
    return c.symbolFor(model, object, context);
  }
  return null;
}
function getSymbolizersFor(objectType) {
  // ToDo: check a handles on the plugins or build type lists
  const filter = symbolizer => {
    if (symbolizer.objectType == null) {
      return true;
    }
    if (typeof symbolizer.objectType === 'string') {
      return symbolizer.objectType === objectType;
    }
    if (Array.isArray(symbolizer.objectType)) {
      return symbolizer.objectType.includes(objectType);
    }
    if (typeof symbolizer.objectType === 'function') {
      return symbolizer.objectType(objectType);
    }
    return false;
  };
  return Plugins.createView('MapBoxSymbolizer', {
    name: objectType,
    filter
  }).get();
}
export default {
  getSymbol,
  getSymbolizersFor,
  SymbolizerFactory
};